import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonSharedModule } from '../common/shared.module';
import { ActivityCountComponent } from './activity-count/activity-count.component';
import { CustomerAcknowledgementQueueComponent } from './customer-acknowledgement-queue/customer-acknowledgement-queue.component';
import { FindingsDocumentComponent } from './findings-document/findings-document.component';
import { InvoiceQueueComponent } from './invoice-queue/invoice-queue.component';
import { CustomerSurveysQueueComponent } from './customer-surveys-queue/customer-surveys-queue.component';
import { RfpAwardLetterComponent } from './rfp-award-letter/rfp-award-letter.component';
import { RfpDescriptionComponent } from './rfp-description/rfp-description.component';
import { AllActivityComponent } from './all-activity/all-activity.component';

@Component({
  selector: 'app-special-investments',
  templateUrl: './special-investments.component.html',
  styleUrls: ['./special-investments.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    ActivityCountComponent,
    CustomerAcknowledgementQueueComponent,
    FindingsDocumentComponent,
    InvoiceQueueComponent,
    CustomerSurveysQueueComponent,
    RfpAwardLetterComponent,
    RfpDescriptionComponent,
    AllActivityComponent
  ]
})
export class SpecialInvestmentsComponent implements OnInit {
  tabList!: HomeTabDetailsModel[];

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  get isEngagmentCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }
}

export class HomeTabDetailsModel {
  hasTabLoaded: boolean;
  isTabSelected: boolean;

  constructor(hasTabLoaded = false, isTabSelected = false) {
    this.hasTabLoaded = hasTabLoaded;
    this.isTabSelected = isTabSelected;
  }
}
